import * as R from "ramda";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { distinctUntilChanged, fromEvent, map, Subject } from "rxjs";

export const getBoundingClientReact = (element) => {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    height: rect.height,
  };
};

export const DetectParentBoundingClientReactChanges = ({ children }) => {
  const ref = useRef(null);

  const [positionChangeSubject$] = useState(new Subject());

  const [valueSubject$] = useState(new Subject());

  const [position, setPosition] = useState({});

  useEffect(() => {
    if (ref.current === null) {
      return;
    }
    const subscriberList = [];
    ["scroll", "resize"].forEach((eventName) => {
      const target =
        ref.current.parentNode || ref.current.parentElement || window;
      const subscriber = fromEvent(target, eventName).subscribe(() => {
        positionChangeSubject$.next();
      });
      subscriberList.push(subscriber);
    });

    const parentNode = ref.current.parentElement;
    //  监听父元素的position, size等变化
    const observer = new window.ResizeObserver(() => {
      positionChangeSubject$.next();
    });
    observer.observe(parentNode);

    const subscriber = positionChangeSubject$
      .pipe(
        map(() => getBoundingClientReact(parentNode)),
        distinctUntilChanged(R.equals)
      )
      .subscribe((info) => {
        valueSubject$.next(info);
      });

    subscriberList.push(subscriber);

    return () => {
      subscriberList.forEach((subscriber) => {
        subscriber.unsubscribe();
      });
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const subscriber = valueSubject$.subscribe((info) => {
      setPosition(info);
    });

    return () => {
      subscriber.unsubscribe();
    };
  }, [valueSubject$]);

  return <div ref={ref}>{children(position)}</div>;
};

export const FixedToItsParent = ({
  children,
  left = 0,
  right = 0,
  top = 0,
  bottom = 0,
}) => {
  const ref = useRef(null);
  return (
    <Fragment>
      <DetectParentBoundingClientReactChanges>
        {(info) => {
          return (
            <div
              ref={ref}
              className="fixed-to-parent-container"
              style={{
                position: "fixed",
                zIndex: 1,
                top: top ? info.top + top : undefined,
                left: left ? window.innerWidth + info.left + left : undefined,
                right: right
                  ? -window.innerWidth +
                    (window.innerWidth - info.left - info.width) +
                    right
                  : undefined,
                bottom: bottom
                  ? window.innerHeight - info.bottom + bottom
                  : undefined,
              }}
            >
              {children}
            </div>
          );
        }}
      </DetectParentBoundingClientReactChanges>
    </Fragment>
  );
};

export const FixedToItsScaleParent = ({
  children,
  left = 0,
  right = 0,
  top = 0,
  bottom = 0,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const parent = ref.current.parentElement;
    //  scale(1) parent
    parent.style.transform = "scale(1)";
  }, [ref]);

  return (
    <span
      ref={ref}
      style={{
        position: "fixed",
        zIndex: 1,
        top: top,
        left: left,
        right: right,
        bottom: bottom,
      }}
    >
      {children}
    </span>
  );
};

export const FloatToItsParent = ({
  children,
  left = 0,
  right = 0,
  top = 0,
}) => {
  return (
    <div
      style={{
        float: "right",
      }}
    >
      {children}
    </div>
  );
};

export const DetectScrollOfParent = ({ children }) => {
  const ref = useRef(null);

  const [top, setTop] = useState(0);

  useEffect(() => {
    if (ref.current === null) {
      return;
    }
    const parentNode = ref.current.parentElement;
    const subscriber = fromEvent(parentNode, "scroll").subscribe(() => {
      setTop(ref.current.parentNode.scrollTop);
    });

    return () => {
      subscriber.unsubscribe();
    };
  }, []);

  return <div ref={ref}>{children(top)}</div>;
};

export const FloatToItsParentRight = ({ children, top = 0, right = 0 }) => {
  return (
    <DetectScrollOfParent>
      {(scrollTop) => {
        return (
          <div
            style={{
              float: "right",
              position: "relative",
              top: top + scrollTop,
              right: right,
            }}
          >
            {children}
          </div>
        );
      }}
    </DetectScrollOfParent>
  );
};



// WEBPACK FOOTER //
// ./src/components/fixed-to-its-parent/index.js